import React, { useContext, useEffect, useState } from 'react';
import styles from './Comment.module.css';
import CommentItem from './CommentItem';
import { PostContext } from '../../../createContext/Post/PostContext';
import IsAuth from '../../../createContext/is-Auth/IsAuthContext';
import { SendHorizontal, X } from 'lucide-react';
import { MatchContext } from '../../../createContext/Match/MatchContext';

const CommentSection = ({
  onClose, 
  postid, 
  matchData, 
  isInline = false
}) => {
  const {getPostById, createComment} = useContext(PostContext);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState(""); 
  const {user} = useContext(IsAuth);
  const {createMatchComment} = useContext(MatchContext);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchComments = async () => {
      setIsLoading(true);
      try {
        if (postid) {
          const res = await getPostById(postid);
          setComments(res.comments);
        } else {
          setComments(matchData?.comments || []);
        }
      } catch (error) {
        console.error('Error fetching comments:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchComments();
  }, [postid, matchData]);

  const handleCommentChange = (e) => {
    setNewComment(e.target.value);  
  };

  const handleSend = async() => {
    setNewComment(newComment.trim());
    if (!newComment.trim()) return;
    let res;
    if (postid) {
      res = await createComment(postid, newComment);
    } else {
      res = await createMatchComment(matchData?._id, newComment);
    }
    setComments(prevComments => [{...res.comment, user:{avatar:user.avatar, userName:user.userName, _id:user._id}}, ...prevComments]);
    setNewComment("");
  };

  return (
    <section className={`${styles.commentSection} ${isInline ? styles.inlineCommentSection : ''}`}>
      {isInline && (
        <div className={styles.inlineCommentsHeader}>
          <div className={styles.commentCount}>
            Comments ({comments.length})
          </div>
          <button 
            onClick={onClose} 
            className={styles.closeInlineComments}
          >
            <X size={20} />
          </button>
        </div>
      )}
      
      <div className={styles.commentList}>
        {isLoading ? (
          <div className={styles.loadingText}>Loading comments...</div>
        ) : comments.length > 0 ? (
          comments.map((comment, index) => (
            <CommentItem key={index} {...comment} />
          ))
        ) : (
          <div className={styles.noComments}>No comments yet</div>
        )}
      </div>
      <div className={styles.commentInputContainerBox}>
        <form className={styles.commentInputContainer}>
          <div className={styles.commentInputWrapper}>
            <img loading="lazy" src={user?.avatar} alt="" className={styles.userAvatar} />
          </div>
          <div className={styles.inputHeader}>
            <input 
              type="text" 
              id="commentInput" 
              style={{ font: "var(--font-secondary)", width: "100%", border: "none", outline: "none" }} 
              placeholder="Add a comment" 
              aria-label="Add a comment" 
              onChange={handleCommentChange}  
              value={newComment}
            />
          </div>
          <SendHorizontal color='gray' style={{cursor:'pointer'}} onClick={handleSend}/>
        </form>
      </div>
    </section>
  );
};

export default CommentSection;